import Controller from "@ember/controller"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import hasMany from "../../helpers/has-many"

export default class SharingController extends Controller {
  @service("ember-store")
  store

  @service
  session

  @service router

  @hasMany("model.planbook", "course", "courses")
  courses

  @hasMany("model.planbook", "class-website", "classWebsites")
  classWebsites

  @action
  toggleLearnMore() {
    this.toggleProperty("showLearnMore")
  }
}
